import { render, staticRenderFns } from "./BannerCreateAndUpdateFormItems.vue?vue&type=template&id=5627d558&"
import script from "./BannerCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"
export * from "./BannerCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"
import style0 from "./BannerCreateAndUpdateFormItems.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5627d558')) {
      api.createRecord('5627d558', component.options)
    } else {
      api.reload('5627d558', component.options)
    }
    module.hot.accept("./BannerCreateAndUpdateFormItems.vue?vue&type=template&id=5627d558&", function () {
      api.rerender('5627d558', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BannerCreateAndUpdateFormItems.vue"
export default component.exports